import { NgModule } from "@angular/core";
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireFunctionsModule, ORIGIN } from '@angular/fire/functions';
import { AngularFireMessagingModule } from '@angular/fire/messaging';

@NgModule({
  declarations: [],
  imports: [
    AngularFireMessagingModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule
  ],
  exports: [
    AngularFireMessagingModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireFunctionsModule
  ],
  /*
  providers: [
    { provide: ORIGIN, useValue: 'http://localhost:5001' }
  ]
  */
})
export class AngularFireUtilsModule { }
